import React, { useEffect } from "react";
import styles from "./style.module.css";
import Navbar from "../../components/Navbar/Navbar";
import { images } from "../../assets/images";
import MissionSection from "./Components/MissionSection";
import TeamSection from "./Components/TeamSection";
import GetInTouch from "./Components/GetInTouch";
import Footer from "../../components/Footer";

const CorporateInfoScreen = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when the component mounts
  }, []);
  const team1 = [
    "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8cHJvZmVzc2lvbmFsfGVufDB8fDB8fHww",
    "https://images.unsplash.com/photo-1556157382-97eda2d62296?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDEyfHx8ZW58MHx8fHx8",
    "https://images.unsplash.com/photo-1589386417686-0d34b5903d23?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDV8fHxlbnwwfHx8fHw%3D",
    "https://images.unsplash.com/photo-1530268729831-4b0b9e170218?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDExfHx8ZW58MHx8fHx8",
    "https://images.unsplash.com/photo-1498758536662-35b82cd15e29?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDd8fHxlbnwwfHx8fHw%3D",
    "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8cHJvZmVzc2lvbmFsfGVufDB8fDB8fHww",
  ];

  const team2 = [
    "https://images.unsplash.com/photo-1530268729831-4b0b9e170218?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDExfHx8ZW58MHx8fHx8",
    "https://images.unsplash.com/photo-1498758536662-35b82cd15e29?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDd8fHxlbnwwfHx8fHw%3D",
    "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8cHJvZmVzc2lvbmFsfGVufDB8fDB8fHww",
  ];
  const { ImageSvg } = images;
  return (
    <div className={styles.mainContainer}>
      <Navbar text="Login/Sign In" />
      <div className={styles.headContainer}>
        <div className={styles.textContainer}>
          <div className={styles.leftText}>
            <h1>Crafting Tomorrow's </h1>
            <h1 className={styles.stroke}>Property Management Experience</h1>
            <p>
              At Avasify, we're reshaping property management for tomorrow. With
              advanced technology and dedicated service, we're leading the way
              towards a more efficient, effective, and enjoyable experience.
              Join us in crafting the future of property management.
            </p>
            <a href="#getInTouch">
              <button>Contact Us</button>
            </a>
          </div>
          <div className={styles.rightImages}>
            <img src={ImageSvg} alt="" />
          </div>
        </div>
      </div>

      <MissionSection />
      <TeamSection team={team1} subTitle="Board of Directors" />
      <TeamSection
        team={team2}
        Title="Behind Success"
        subTitle="Leadership/Team"
      />
      <GetInTouch />
      <Footer />
    </div>
  );
};

export default CorporateInfoScreen;
